import React from 'react';

export const MuteSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="22"
    height="16"
    viewBox="0 0 22 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8174 14.9681C11.8174 15.3684 11.577 15.7321 11.2007 15.9018C11.0552 15.968 10.8994 16 10.7445 16C10.4992 16 10.2563 15.9189 10.06 15.7624L4.19589 11.0876H1.07265C0.480344 11.088 0 10.6257 0 10.0559V5.94455C0 5.37449 0.480344 4.91239 1.07265 4.91239H4.19615L10.0603 0.237595C10.3807 -0.0178819 10.825 -0.0723479 11.201 0.0986215C11.577 0.26837 11.8177 0.63229 11.8177 1.03236L11.8174 14.9681Z"
      fill="currentColor"
    />
    <path
      d="M18.8994 8.03949L21.8557 5.19529C22.0481 5.01028 22.0481 4.71116 21.8557 4.52615C21.6634 4.34115 21.3525 4.34115 21.1602 4.52615L18.2038 7.37036L15.2475 4.52615C15.0551 4.34115 14.7443 4.34115 14.552 4.52615C14.3596 4.71116 14.3596 5.01028 14.552 5.19529L17.5083 8.03949L14.552 10.8837C14.3596 11.0687 14.3596 11.3678 14.552 11.5528C14.6478 11.6451 14.7738 11.6915 14.8997 11.6915C15.0256 11.6915 15.1516 11.6451 15.2475 11.5528L18.2038 8.70863L21.1602 11.5528C21.2561 11.6451 21.382 11.6915 21.5079 11.6915C21.6339 11.6915 21.7598 11.6451 21.8557 11.5528C22.0481 11.3678 22.0481 11.0687 21.8557 10.8837L18.8994 8.03949Z"
      fill="currentColor"
    />
  </svg>
);

export default MuteSvg;
